/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

import React from 'react';

import { request } from '@mairistem/tools';
import { Image, Loader, Message } from '@mairistem/composants';

import { attestation } from '@/routes';
import {
  base64ToUint8Array,
  renderPdfPageToDataURL,
} from '@/utils/pdf-helpers';

import { Section } from '../../Common';

interface StepAttestationProps {
  identifiant: number;
}

export const StepAttestation = (props: StepAttestationProps) => {
  const { identifiant } = props;

  const [pdfUrl, setPdfUrl] = React.useState<string | null>(null);
  const [loading, setLoading] = React.useState<boolean>(false);
  const [error, setError] = React.useState<boolean>(false);

  React.useEffect(() => {
    if (!identifiant) {
      return;
    }

    setLoading(true);
    setError(false);

    const body = {
      preImprime: false,
      editeDateAttestation: true,
      margeHaute: 0,
      margeGauche: 0,
    };

    request
      .post(attestation(identifiant), body, {
        headers: { Accept: '*/*' },
        responseType: 'blob',
      })
      .then((response: any) => {
        // Convertir le blob en base64
        const reader = new FileReader();
        reader.onloadend = async () => {
          try {
            const base64String = reader.result as string;
            const base64Data = base64String.split(',')[1];

            // Convertir en Uint8Array et rendre la première page du PDF
            const pdfData = base64ToUint8Array(base64Data);
            const dataUrl = await renderPdfPageToDataURL(pdfData, 1, 800);
            setPdfUrl(dataUrl);
          } catch (_err) {
            setError(true);
          } finally {
            setLoading(false);
          }
        };
        reader.onerror = () => {
          setError(true);
          setLoading(false);
        };
        reader.readAsDataURL(response);
      })
      .catch(() => {
        setError(true);
        setLoading(false);
      });
  }, [identifiant]);

  return (
    <Section title="ATTESTATION DE RECENSEMENT">
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'flex-start',
          width: '100%',
          height: '100%',
          overflow: 'auto',
        }}
      >
        {loading && (
          <div style={{ textAlign: 'center', padding: '2em' }}>
            <Loader active inline="centered" size="large">
              Chargement de l&apos;attestation...
            </Loader>
          </div>
        )}

        {error && !loading && (
          <Message negative style={{ maxWidth: '600px', margin: '2em auto' }}>
            <Message.Header>Erreur</Message.Header>
            <p>Impossible de charger l&apos;attestation de recensement.</p>
          </Message>
        )}

        {pdfUrl && !loading && !error && (
          <div
            style={{
              width: '100%',
              height: '100%',
              display: 'flex',
              justifyContent: 'center',
              padding: '1rem',
            }}
          >
            <Image
              src={pdfUrl}
              style={{
                maxWidth: '100%',
                maxHeight: '100%',
                width: 'auto',
                height: 'auto',
                objectFit: 'contain',
              }}
              alt="Attestation de recensement"
            />
          </div>
        )}
      </div>
    </Section>
  );
};

export default StepAttestation;
